<template>
  <v-container fluid>
    <div class="dashboard-page">
      <v-card width="100%" class="breadcrumbs mx-1 mb-6">
        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-md-start justify-space-between align-center"
          >
            <h1 class="main-page-title greyMedium--text mb-0 mr-2 pt-4 pt-md-0">
              Dashboard
            </h1>
            <div class="ml-0 ml-sm-4">
              <v-tabs color="secondary"> </v-tabs>
            </div>
          </v-col>

          <v-col
            cols="12"
            md="6"
            class="d-sm-flex justify-space-between align-center justify-md-end"
          >
            <div class="mb-3 mb-sm-0">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedDate"
                    prepend-icon="mdi-calendar"
                    color="primary"
                    full-width
                    style="height: 38px; width: 250px"
                    readonly
                    single-line
                    solo
                    flat
                    dense
                    class="main-date-picker mr-2"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-row no-gutters>
        <v-col cols="8">
          <v-card class="support-card ma-1">
            <v-card-title> Progresso Geral </v-card-title>
            <v-card-text>
              <ApexChart
                type="radialBar"
                height="320"
                :options="mockProjeto.apexSimpleRadialBarGeral.options"
                :series="[
                  progressoImpacto,
                  progressoRealizacao,
                  progressoProduto,
                  progressoAtividade,
                ]"
              ></ApexChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="support-card ma-1">
            <v-card-title> Impacto </v-card-title>
            <v-card-text>
              <ApexChart
                height="320"
                :options="mockProjeto.apexSimpleRadialBarImpacto.options"
                :series="[progressoImpacto]"
              ></ApexChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="support-card ma-1">
            <v-card-title> Realização </v-card-title>
            <v-card-text>
              <ApexChart
                height="320"
                :options="mockProjeto.apexSimpleRadialBarRealizacao.options"
                :series="[progressoRealizacao]"
              ></ApexChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="support-card ma-1">
            <v-card-title> Produtos </v-card-title>
            <v-card-text>
              <ApexChart
                height="320"
                :options="mockProjeto.apexSimpleRadialBarProduto.options"
                :series="[progressoProduto]"
              ></ApexChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="support-card ma-1">
            <v-card-title> Atividades </v-card-title>
            <v-card-text>
              <ApexChart
                height="320"
                :options="mockProjeto.apexSimpleRadialBarAtividade.options"
                :series="[progressoAtividade]"
              ></ApexChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <v-card class="support-card ma-1">
            <v-card-title class="d-flex flex-nowrap pa-5 pb-0"> Atividades </v-card-title>
            <v-card-text class="pa-5 pt-0">
              <ApexChart
                type="bar"
                height="350"
                :options="mockProjeto.apexBarAtividades.options"
                :series="serieProgressoAtividades"
              ></ApexChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3" v-if="0">
          <v-card class="support-card ma-1" height="280">
            <v-card-title class="d-flex flex-nowrap pa-5 pb-0">
              <v-row no-gutters class="pb-0">
                <v-col cols="8" class="my-auto">
                  <p class="text-truncate">1.1 Produto</p>
                </v-col>
                <v-col cols="4" class="text-right">
                  <ApexChart
                    v-if="apexLoading"
                    height="120"
                    :options="mockProjeto.apexPie1.options"
                    :series="mockProjeto.apexPie1.series"
                  ></ApexChart>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text class="pa-5 pt-0">
              <v-row no-gutters class="pb-6">
                <div class="mr-4">
                  <v-icon color="primaryConst" class="ml-n2"> mdi-circle-medium </v-icon>
                  <span class="greyTint--text">Integration</span>
                </div>
                <div>
                  <v-icon color="warning"> mdi-circle-medium </v-icon>
                  <span class="greyTint--text">SDK</span>
                </div>
              </v-row>
              <v-row no-gutters class="pb-4">
                <v-col>
                  <div class="text-h6 greyBold--text font-weight-regular">
                    Integration
                  </div>
                  <v-progress-linear
                    :value="value"
                    background-color="#ececec"
                    color="primaryConst"
                  ></v-progress-linear>
                </v-col>
              </v-row>
              <v-row no-gutters class="pb-4">
                <v-col>
                  <div class="text-h6 greyBold--text font-weight-regular">SDK</div>
                  <v-progress-linear
                    :value="value2"
                    background-color="#ececec"
                    color="warning"
                  ></v-progress-linear>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          lg="4"
          sm="6"
          md="8"
          cols="12"
          v-for="(produto, index) in produtos"
          :key="index"
        >
          <v-card class="ma-1">
            <v-card-title class="d-flex flex-nowrap pa-5 pb-3">
              <v-tooltip nudge-right="184" max-width="500" top>
                <template v-slot:activator="{ on, attrs }">
                  <p v-bind="attrs" v-on="on" class="text-capitalize">
                    {{ textCapitalize(produto.nivelFormatado) }}
                  </p>
                </template>
                <span> {{ produto.descricao }} </span>
              </v-tooltip>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pa-5 pt-0">
              <v-row no-gutters class="pb-6">
                <div class="mr-4">
                  <v-icon color="primaryConst" class="ml-n2"> mdi-circle-medium </v-icon>
                  <span class="greyTint--text">Atividades</span>
                </div>
                <div>
                  <v-icon color="warning"> mdi-circle-medium </v-icon>
                  <span class="greyTint--text">Indicadores</span>
                </div>
                <div style="margin: -85px 0px 0 380px !important">
                  <ApexChart
                    v-if="apexLoading"
                    height="140"
                    :options="mockProjeto.apexPie1.options"
                    :series="[produto.progressoLogicaIntervencao]"
                  ></ApexChart>
                </div>
              </v-row>

              <v-row no-gutters class="mt-n2 pb-4">
                <v-col>
                  <div class="d-flex">
                    <div class="text-h6 greyBold--text font-weight-regular">
                      Atividades
                    </div>
                    <v-spacer></v-spacer>
                    <div class="text-subtitle-1">
                      <span class="font-weight-black">
                        {{ produto.resumoAtividade.atividadesConcluidas }}
                      </span>
                      /
                      <span class="grey--text text--darken-2">
                        {{ produto.resumoAtividade.numeroDeAtividades }}
                      </span>
                    </div>
                  </div>
                  <v-progress-linear
                    height="16"
                    :value="produto.resumoAtividade.progressoAtividades"
                    background-color="#ececec"
                    color="primaryConst"
                  >
                    <span class="font-weight-medium grey--text"
                      >{{ produto.resumoAtividade.progressoAtividades }}%</span
                    >
                  </v-progress-linear>
                </v-col>
              </v-row>
              <v-row no-gutters class="pb-4">
                <v-col>
                  <div class="d-flex">
                    <div class="text-h6 greyBold--text font-weight-regular">
                      Indicadores
                    </div>
                    <v-spacer></v-spacer>
                    <div class="text-subtitle-1">
                      <span class="font-weight-black">
                        {{ produto.resumoIndicador.indicadoresConcluidos }}
                      </span>
                      /
                      <span class="grey--text text--darken-2">
                        {{ produto.resumoIndicador.numeroDeIndicadores }}
                      </span>
                    </div>
                  </div>
                  <v-progress-linear
                    height="16"
                    :value="produto.resumoIndicador.progressoIndicadores"
                    background-color="#ececec"
                    color="warning"
                  >
                    <span class="font-weight-medium grey--text"
                      >{{ produto.resumoIndicador.progressoIndicadores }}%</span
                    >
                  </v-progress-linear>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card class="support-table ma-1">
            <v-card-title class="pa-5 pb-4">
              <p>Lógicas de Intervenção</p>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="4">
                  <v-select
                    append-icon="mdi-filter"
                    label="NÍVEL"
                    v-model="nivelIntervencaoFilterValue"
                    attach
                    outlined
                    chips
                    multiple
                    :items="niveisItems"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip class="mt-3" color="primary">
                        <span>{{ item }}</span>
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text class="pa-0 overflow-x-auto">
              <v-data-table
                :headers="headersIntervencoes"
                :items="intervencoes"
                :items-per-page="itemPerPage"
              >
                <template v-slot:item.nivelFormatado="{ item }">
                  <v-chip small> {{ item.nivelFormatado }} </v-chip>
                </template>

                <template v-slot:item.descricao="{ item }">
                  <template v-if="item.logicaIntervencao">
                    <span class="caption">
                      {{ item.logicaIntervencao.nivelFormatado }}
                    </span>
                    <v-icon small>mdi-chevron-right</v-icon>
                  </template>

                  <span class="caption"> {{ item.nivelFormatado }} </span> <br />
                  {{ item.descricao }}
                </template>

                <template v-slot:item.resumoIndicador="{ item }">
                  {{ item.resumoIndicador.indicadoresConcluidos }} /
                  {{ item.resumoIndicador.numeroDeIndicadores }}
                </template>

                <template v-slot:item.progressoLogicaIntervencao="{ item }">
                  <v-progress-linear height="30" :value="item.progressoLogicaIntervencao">
                    <strong>{{ item.progressoLogicaIntervencao }}%</strong>
                  </v-progress-linear>
                </template>
                <template v-slot:no-data> </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="support-table ma-1">
            <v-card-title class="pa-5 pb-4">
              <p>Indicadores</p>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="4">
                  <v-select
                    append-icon="mdi-filter"
                    label="NÍVEL"
                    v-model="nivelIndicadorFilterValue"
                    attach
                    outlined
                    chips
                    multiple
                    :items="niveisItems"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip class="mt-3" color="primary">
                        <span>{{ item }}</span>
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text class="pa-0 overflow-x-auto">
              <v-data-table
                :headers="headersIndicadores"
                :items="indicadores"
                :items-per-page="itemPerPage"
              >
                <template v-slot:item.logicaIntervencao.nivelFormatado="{ item }">
                  <v-tooltip right nudge-right="20%" max-width="900" color="primary">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip v-bind="attrs" v-on="on" small>
                        {{ item.logicaIntervencao.nivelFormatado }}
                      </v-chip>
                    </template>
                    <span> {{ item.logicaIntervencao.descricao }} </span>
                  </v-tooltip>
                </template>

                <template v-slot:item.progresso="{ item }">
                  <v-progress-linear
                    height="30"
                    color="primary"
                    :value="item.porcentagemTotalAtingido"
                  >
                    <strong> {{ item.porcentagemTotalAtingido }}%</strong>
                  </v-progress-linear>
                </template>
                <template v-slot:no-data> </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import mockProjeto from "./mockProjeto";
import ApexChart from "vue-apexcharts";
import moment from "moment";

export default {
  name: "Dashboard",
  components: {
    ApexChart,
  },
  data() {
    return {
      descricaoNivel: {
        OBJETIVO_GERAL: "IMPACTO",
        OBJETIVO_ESPECIFICO: "REALIZAÇÃO",
        RESULTADO_ESPERADO: "PRODUTO",
        ATIVIDADE: "ATIVIDADE",
      },
      niveisItems: ["IMPACTO", "REALIZAÇÃO", "PRODUTO", "ATIVIDADE"],
      nivelIndicadorFilterValue: ["IMPACTO", "REALIZAÇÃO", "PRODUTO", "ATIVIDADE"],
      nivelIntervencaoFilterValue: ["IMPACTO", "REALIZAÇÃO", "PRODUTO", "ATIVIDADE"],
      mockProjeto,
      apexLoading: false,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      headersIndicadores: [
        {
          text: "NÍVEL",
          value: "logicaIntervencao.nivelFormatado",
          width: "12%",
          filter: this.nivelIndicadoresFilter,
        },
        { text: "TÍTULO", value: "titulo", width: "68%" },
        { text: "PROGRESSO ATUAL (%)", value: "progresso", width: "20%" },
      ],
      headersIntervencoes: [
        {
          text: "NÍVEL",
          value: "nivelFormatado",
          width: "12%",
          filter: this.nivelIntervencaoFilter,
        },
        { text: "TÍTULO", value: "descricao", width: "50%" },
        { text: "INDICADORES", value: "resumoIndicador", width: "18%" },
        {
          text: "PROGRESSO ATUAL (%)",
          value: "progressoLogicaIntervencao",
          width: "20%",
        },
      ],
      itemPerPage: 5,
    };
  },
  methods: {
    textCapitalize(text) {
      return text.toLowerCase().replace(/\w/, (firstLetter) => firstLetter.toUpperCase());
    },

    nivelIndicadoresFilter(value) {
      return this.nivelIndicadorFilterValue.some((nivel) => value.includes(nivel));
    },

    nivelIntervencaoFilter(value) {
      return this.nivelIntervencaoFilterValue.some((nivel) => value.includes(nivel));
    },
  },
  computed: {
    computedDate() {
      return this.date ? moment(this.date).format("Do MMM YYYY, dddd") : "";
    },

    intervencoes() {
      return this.$store.getters["logicaIntervencao/byProjeto"](
        parseInt(this.$route.params.projetoId)
      );
    },

    categoriesAtividades() {
      return this.intervencoes
        .filter((logicaIntervencao) => logicaIntervencao.nivel === "ATIVIDADE")
        .map((intervencao) => {
          return [
            intervencao.logicaIntervencao.nivelFormatado,
            intervencao.nivelFormatado,
            intervencao.descricao,
          ];
        });
    },

    serieProgressoAtividades() {
      return [
        {
          name: "Progresso da Atividade",
          data: this.intervencoes
            .filter((logicaIntervencao) => logicaIntervencao.nivel === "ATIVIDADE")
            .map((intervencao) => {
              return intervencao.progressoLogicaIntervencao;
            }),
        },
      ];
    },

    produtos() {
      return this.intervencoes
        .filter((logicaIntervencao) => logicaIntervencao.nivel === "RESULTADO_ESPERADO")
        .sort((a, b) =>
          a.posicaoFormatada > b.posicaoFormatada
            ? 1
            : b.posicaoFormatada > a.posicaoFormatada
            ? -1
            : 0
        );
    },

    intervencoesbyProjeto() {
      return this.$store.getters["logicaIntervencao/byProjeto"](
        parseInt(this.$route.params.projetoId)
      );
    },

    indicadores() {
      return this.$store.getters["indicador/all"];
    },

    progressoImpacto() {
      let impacto = this.intervencoes.filter(
        (logicaIntervencao) => logicaIntervencao.nivel === "OBJETIVO_GERAL"
      );
      if (impacto.length) {
        return impacto[0].progressoLogicaIntervencao;
      }
      return 0.0;
    },

    progressoRealizacao() {
      let realizacao = this.intervencoes.filter(
        (logicaIntervencao) => logicaIntervencao.nivel === "OBJETIVO_ESPECIFICO"
      );
      if (realizacao.length) {
        return realizacao[0].progressoLogicaIntervencao;
      }
      return 0.0;
    },

    progressoProduto() {
      if (this.produtos.length) {
        let sum = parseFloat(
          this.produtos.reduce((accumulator, produto) => {
            return accumulator + produto.progressoLogicaIntervencao;
          }, 0.0)
        );
        return parseFloat(parseFloat(sum / this.produtos.length).toFixed(2));
      }

      return 0.0;
    },

    progressoAtividade() {
      if (this.produtos.length) {
        let sum = parseFloat(
          this.produtos.reduce((accumulator, produto) => {
            return accumulator + produto.resumoAtividade.progressoAtividades;
          }, 0.0)
        );
        return parseFloat(parseFloat(sum / this.produtos.length).toFixed(2));
      }

      return 0.0;
    },
  },

  mounted() {
    setTimeout(() => {
      this.apexLoading = true;
    });
  },

  created() {
    this.mockProjeto.apexBarAtividades.options.xaxis.categories = this.categoriesAtividades;
  },
};
</script>

<style src="./Dashboard.scss" lang="scss" />
